import { render } from "./FeederList.vue?vue&type=template&id=8b5abcfc&scoped=true"
import script from "./FeederList.vue?vue&type=script&lang=js"
export * from "./FeederList.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-8b5abcfc"

export default script